<script setup lang="ts">
    import type { FrontendFieldDefinition } from '@hmmh/storyblok-forms';
    import type { FormRadioGroupStoryblok } from '~/.storyblok/types/FormRadioGroupStoryblok';
    import FormRadioGroup from '~/storyblok/Form/FormRadioGroup.vue';
    import { isRequiredField } from './form-field-utils';

    const props = defineProps<{ field: FrontendFieldDefinition }>();

    const blok = computed<FormRadioGroupStoryblok>(() => ({
        _uid: props.field.name,
        component: 'FormRadioGroup',
        inputKey: props.field.name,
        title: `${props.field.label}${isRequiredField(props.field) ? ' *' : ''}`,
        options: (props.field.options ?? []).map((option) => ({
            _uid: `${props.field.name}-${option.key}`,
            component: 'FormRadioInput',
            label: option.value,
            value: option.key
        }))
    }));
</script>

<template>
    <FormRadioGroup
        :blok="blok"
        val=""
    />
</template>
